import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      menuList: [{
        id: 1,
        text: "首页",
        name: "home",
        defaultIcon: "".concat(this.$ossUrl, "/home_default.png"),
        activeIcon: "".concat(this.$ossUrl, "/home_active.png")
      }, {
        id: 2,
        text: "生活圈",
        name: "shop",
        defaultIcon: "".concat(this.$ossUrl, "/business_default.png"),
        activeIcon: "".concat(this.$ossUrl, "/business_active.png")
      }, {
        id: 4,
        text: "权益专区",
        name: "pointsMall",
        defaultIcon: "".concat(this.$ossUrl, "/mall_default.png"),
        activeIcon: "".concat(this.$ossUrl, "/mall_active.png")
      }, {
        id: 6,
        text: "购物车",
        name: "cart",
        defaultIcon: "".concat(this.$ossUrl, "/member_shop.png"),
        activeIcon: "".concat(this.$ossUrl, "/member_shop_active.png")
      }, {
        id: 5,
        text: "我的",
        name: "member",
        defaultIcon: "".concat(this.$ossUrl, "/my_default.png"),
        activeIcon: "".concat(this.$ossUrl, "/my_active.png")
      }],
      active: ""
    };
  },
  mounted: function mounted() {
    this.getCurrentPage();
  },
  watch: {
    $route: function $route(to, from) {
      this.getCurrentPage();
    }
  },
  methods: {
    getCurrentPage: function getCurrentPage() {
      var routeName = this.$route.name || "";
      switch (routeName) {
        case "home":
          this.active = 1;
          break;
        case "newDiy":
          this.active = 2;
          break;
        case "luckly":
          this.active = 3;
          break;
        case "pointsMall":
          this.active = 4;
          break;
        case "member":
          this.active = 5;
          break;
        case "cart":
          this.active = 6;
          break;
        default:
          this.active = "";
          break;
      }
    },
    gotoPage: function gotoPage(item) {
      if (this.active == item.id) return;
      this.active = item.id;
      switch (item.name) {
        case "home":
          this.$router.push(this.fun.getUrl("home"));
          break;
        case "shop":
          this.$router.push(this.fun.getUrl("newDiy", {}, {
            page_id: 4
          }));
          break;
        case "luckly":
          this.$router.push(this.fun.getUrl("luckly"));
          break;
        case "pointsMall":
          this.$router.push(this.fun.getUrl("pointsMall"));
          break;
        case "cart":
          this.$router.push(this.fun.getUrl("cart"));
          break;
        case "member":
          this.$router.push(this.fun.getUrl("member"));
          break;
      }
    }
  }
};